// extracted by mini-css-extract-plugin
module.exports = {"info-message":"magazine-page-m__info-message__7t_KG"};